// const chartAdvData = {
//   seriesSingle: [
//     {
//       name: "Target Revenue",
//       data: [520, 620, 750, 580, 786, 665, 870, 882, 595, 882, 986, 1100],
//     },
//     {
//       name: "Revenue Achieved",
//       data: [570, 610, 780, 550, 789, 569, 944, 852, 620, 790, 900, 1120],
//     },
//   ],
//   series: [
//     {
//       seriesName: "Omkar",
//       seriesData: [
//         {
//           name: "Target Revenue",
//           data: [520, 620, 750, 580, 786, 665, 870, 882, 595, 882, 986, 1100],
//         },
//         {
//           name: "Revenue Achieved",
//           data: [570, 610, 780, 550, 789, 569, 944, 852, 620, 790, 900, 1120],
//         },
//       ],
//     },
//     {
//       seriesName: "Pinaka",
//       seriesData: [
//         {
//           name: "Target Revenue",
//           data: [610, 540, 720, 680, 810, 760, 890, 920, 870, 940, 1020, 1150],
//         },
//         {
//           name: "Revenue Achieved",
//           data: [590, 560, 705, 640, 825, 730, 910, 905, 850, 960, 990, 1180],
//         },
//       ],
//     },
//   ],

//   projection: [840, 850, 880, 840, 850, 870, 890, 810, 780, 800, 840, 890],
//   categories: [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ],
// };
/////////////////////////////////
/////////////////////////////////
/////////////////////////////////
/////////////////////////////////

const userNames = [
  "Aarav Sharma",
  "Vivaan Verma",
  "Aditya Singh",
  "Rohan Gupta",
  "Kunal Mehta",
  "Rahul Malhotra",
  "Suresh Iyer",
  "Amit Patel",
  "Nikhil Jain",
  "Vikas Agarwal",
  "Ankit Mishra",
  "Manish Tiwari",
  "Sandeep Yadav",
  "Pankaj Chauhan",
  "Deepak Saxena",
  "Rajesh Khanna",
  "Sunil Chawla",
  "Abhishek Roy",
  "Prashant Kulkarni",
  "Arjun Nair",
  "Ananya Sharma",
  "Aishwarya Rao",
  "Sneha Iyer",
  "Pooja Mehta",
  "Neha Gupta",
  "Ritika Malhotra",
  "Kavya Verma",
  "Priya Singh",
  "Swati Jain",
  "Nisha Patel",
  "Shreya Banerjee",
  "Rashmi Kulkarni",
  "Divya Choudhary",
  "Isha Kapoor",
  "Komal Saxena",
  "Bhavna Mishra",
  "Meenal Agarwal",
  "Sakshi Tiwari",
  "Renu Yadav",
  "Preeti Chauhan",
  "Mohit Bansal",
  "Harshit Goyal",
  "Akash Dubey",
  "Saurabh Pandey",
  "Vinayak Deshpande",
  "Anil Joshi",
  "Siddharth Sinha",
  "Varun Arora",
  "Ashish Rathi",
  "Kapil Singhal",
  "Pallavi Joshi",
  "Tanvi Deshpande",
  "Kirti Sinha",
  "Madhuri Rao",
  "Alka Arora",
  "Payal Rathi",
  "Sonali Goyal",
  "Monika Bansal",
  "Aditi Pandey",
  "Riya Dubey",
  "Yogesh Thakur",
  "Hemant Bhatt",
  "Ramesh Pillai",
  "Girish Hegde",
  "Balaji Krishnan",
  "Murugan Subramanian",
  "Pradeep Reddy",
  "Naveen Chandra",
  "Santosh Naik",
  "Mahesh Patil",
];
const roles = ["Super Admin", "Manager", "Team Lead", "Employee"];
//////////////////////////////////////////////////////////////////
function mulberry32(seed) {
  let t = seed >>> 0;
  return () => {
    t += 0x6d2b79f5;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}
function toEmail(name, id, domain) {
  const local = String(name)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ".")
    .replace(/^\.+|\.+$/g, "");
  return `${local}.${id}@${domain}`;
}
function randInt(rng, min, max) {
  const lo = Math.ceil(min);
  const hi = Math.floor(max);
  return Math.floor(rng() * (hi - lo + 1)) + lo;
}
function makeNamePicker(names, rng) {
  let idx = 0;
  return () => {
    if (!Array.isArray(names) || names.length === 0) return `User ${idx++}`;
    const jitter = randInt(rng, 0, Math.max(0, names.length - 1));
    const name = names[(idx + jitter) % names.length];
    idx += 1;
    return name;
  };
}
function generateOrgHierarchy({
  superAdminCount = 1,
  managerCount = 3,
  teamLeadMin = 1,
  teamLeadMax = 2,
  employeeMin = 2,
  employeeMax = 3,
  seed = 42,
  emailDomain = "example.com",
} = {}) {
  const rng = mulberry32(seed);
  const pickName = makeNamePicker(userNames, rng);

  let nextId = 1;
  const nodes = [];
  const superAdmins = [];

  for (let i = 0; i < superAdminCount; i += 1) {
    const id = nextId++;
    superAdmins.push(id);
    const name = pickName();
    nodes.push({
      id,
      name,
      email: toEmail(name, id, emailDomain),
      role: roles[0],
      managerId: null,
    });
  }

  const rootId = superAdmins[0] ?? null;

  const managerIds = [];
  for (let i = 0; i < managerCount; i += 1) {
    const id = nextId++;
    managerIds.push(id);
    const name = pickName();
    nodes.push({
      id,
      name,
      email: toEmail(name, id, emailDomain),
      role: roles[1],
      managerId: rootId,
    });
  }

  managerIds.forEach((mId) => {
    const teamLeadCount = randInt(rng, teamLeadMin, teamLeadMax);
    for (let i = 0; i < teamLeadCount; i += 1) {
      const teamLeadId = nextId++;
      const leadName = pickName();
      nodes.push({
        id: teamLeadId,
        name: leadName,
        email: toEmail(leadName, teamLeadId, emailDomain),
        role: roles[2],
        managerId: mId,
      });

      const employeeCount = randInt(rng, employeeMin, employeeMax);
      for (let j = 0; j < employeeCount; j += 1) {
        const empId = nextId++;
        const empName = pickName();
        nodes.push({
          id: empId,
          name: empName,
          email: toEmail(empName, empId, emailDomain),
          role: roles[3],
          managerId: teamLeadId,
        });
      }
    }
  });

  return nodes;
}
const employeeList = generateOrgHierarchy();
/////////////////////////////////////
const duration = {
  startDate: "2025-12-01",
  // endDate: "2025-11-30",
  endDate: new Date().toISOString().split("T")[0], // today,
};
const infoData = ["jobOpenings", "contacts", "accounts", "confirm"];
function parseIsoDateToUtc(isoDate) {
  if (isoDate instanceof Date && !Number.isNaN(isoDate.getTime())) {
    return new Date(
      Date.UTC(isoDate.getFullYear(), isoDate.getMonth(), isoDate.getDate())
    );
  }

  const raw = String(isoDate);
  const dateOnly = raw.includes("T") ? raw.split("T")[0] : raw;
  const parts = dateOnly.split("-");
  const year = Number(parts[0]);
  const monthIndex = Number(parts[1]) - 1;
  const day = Number(parts[2]);
  return new Date(Date.UTC(year, monthIndex, day));
}
function formatUtcDateToIso(date) {
  return new Date(date.getTime()).toISOString().slice(0, 10);
}
function getIsoDateRangeInclusive(startDate, endDate) {
  const start = parseIsoDateToUtc(startDate);
  const end = parseIsoDateToUtc(endDate);
  const result = [];

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
    return result;

  const cursor = start;
  while (cursor.getTime() <= end.getTime()) {
    result.push(formatUtcDateToIso(cursor));
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }

  return result;
}
function generateDailyData({
  employees = employeeList,
  startDate = duration.startDate,
  endDate = duration.endDate,
  seed = 20250101,
} = {}) {
  const dates = getIsoDateRangeInclusive(startDate, endDate);

  return (Array.isArray(employees) ? employees : []).map((employee) => {
    if (!employee || employee.role === "Super Admin") return employee;

    const userSeed = seed + Number(employee.id ?? 0) * 1009;
    const rng = mulberry32(userSeed);

    const dailyData = dates.map((date) => {
      const jobOpenings = randInt(rng, 0, 30);
      const contacts =
        jobOpenings === 0 ? 0 : randInt(rng, jobOpenings * 1, jobOpenings * 5);
      const accounts =
        jobOpenings === 0 ? 0 : randInt(rng, 0, Math.max(0, jobOpenings));
      const confirm =
        accounts === 0 ? 0 : randInt(rng, 0, Math.max(0, accounts));

      return {
        date,
        reportData: { jobOpenings, contacts, accounts, confirm },
      };
    });

    return { ...employee, dailyData };
  });
}

const employeeListWithDailyData = generateDailyData();
///////////////////////////////////////
function generateChartAdvData({
  employees = employeeListWithDailyData,
  startDate = duration.startDate,
  endDate = duration.endDate,
} = {}) {
  const categories = getIsoDateRangeInclusive(startDate, endDate);
  const safeEmployees = Array.isArray(employees) ? employees : [];

  const series = safeEmployees
    .filter((e) => e && e.role !== "Super Admin")
    .map((e) => {
      const daily = Array.isArray(e.dailyData) ? e.dailyData : [];
      const byDate = new Map(daily.map((d) => [d?.date, d?.reportData || {}]));

      const valuesFor = (key) =>
        categories.map((date) => {
          const v = byDate.get(date)?.[key];
          return v != null && Number.isFinite(Number(v)) ? Number(v) : 0;
        });

      return {
        seriesName: e.name,
        seriesId: e.id,
        seriesData: [
          { name: "Job Openings", data: valuesFor("jobOpenings") },
          { name: "Contacts", data: valuesFor("contacts") },
          { name: "Accounts", data: valuesFor("accounts") },
          { name: "Confirm", data: valuesFor("confirm") },
        ],
      };
    });

  return { categories, series };
}
const chartAdvDataNew = generateChartAdvData();
//////////////////////////////

function getChartAdvMetricsLocal({ from, to, employeeId, employeeIds } = {}) {
  const ids = Array.isArray(employeeIds)
    ? employeeIds
    : employeeId != null && employeeId !== ""
    ? [employeeId]
    : null;

  const filteredEmployees = ids
    ? employeeListWithDailyData.filter((e) => e && ids.includes(e.id))
    : employeeListWithDailyData;

  return generateChartAdvData({
    employees: filteredEmployees,
    startDate: from,
    endDate: to,
  });
}

export { chartAdvDataNew, getChartAdvMetricsLocal };
